export default {
  country_locale: 'en-GB',
  wia_title: 'Web Intervention Avoidance',
  wia_need_help: 'I need help with a',
  wia_model_name: 'The model name is',
  wia_back: '< change',
  wia_confirm: 'Confirm',
  wia_issue_title: 'What is your issue?',
  wia_issue_concern: 'My issue concerns',
  wia_issue_specific: 'Specify your issue',
  wia_possible_solution: 'Possible solutions',
  wia_solved_issue: 'Solved the problem?',
  wia_closed: 'Close X',
  wia_feedback_ok: ' Yes!',
  wia_find_another_solution: 'Find another solution',
  wia_feedback_title: 'We are glad the problem was solved!',
  wia_feedback_text1: 'Visit our store with special offers dedicated to you',
  wia_feedback_text2: 'Learn more about our newest smart technologies!',
  wia_smile_up_popup_text1: 'Discover our protection plans',
  wia_smile_down_popup_title: 'Need more help?',
  wia_smile_down_popup_text1: 'Go to the second step',
  wia_smile_down_popup_or_text: 'or',
  wia_smile_down_popup_text2: 'Book an intervention',
  wia_need_more_help: 'Need more help?',
  wia_optional_label: '(optional)',
  wia_no_solution: 'Unfortunately there are no straightforward self-service solutions for your issue. Please click here for support.',
  wia_all_solution: 'All the results',
  wia_all_categories: 'All the categories',
  wia_seo_l1_issue: 'All faults by category',
  wia_seo_wp_country_name: 'UK',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'UK',
  wia_seo_wp_meta_title: 'Problems and Solutions',
  wia_seo_bk_meta_title: 'Problems and Solutions',
  wia_seo_hp_meta_title: 'Problems and Solutions',
  wia_seo_id_meta_title: 'Problems and Solutions',
  wia_seo_wp_meta_description: '',
  wia_seo_bk_meta_description: '',
  wia_seo_hp_meta_description: '',
  wia_seo_id_meta_description: '',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
